export enum BusinessRegistrationType {
  PrivateLimitedCompany = 'Private Limited Company',
  PublicLimitedCompany = 'Public Limited Company',
  Partnerships = 'Partnerships',
  LlpRegistration = 'LLP Registration',
  OnePersonCompany = 'Individual/Freelancer',
  SoleProprietorship = 'Sole Proprietorship',
  Section8Company = 'Section 8 Company',
}
